module.exports = __webpack_public_path__ + "own.cc0ecbbefd9ad721529ebcb876b7b307.png";